import {configureStore as configureStoreRedux} from '@reduxjs/toolkit';
import {createEpicMiddleware} from 'redux-observable';
import rootReducer from '../reducers/rootReducer';
import {rootEpic} from '../epics/rootEpic';

export default function configureStore (preloadedState = {}) {
  const epicMiddleware = createEpicMiddleware();

  // Use middleware callback to get default middleware and add epicMiddleware
  const store = configureStoreRedux({
    reducer: rootReducer,
    preloadedState,
    middleware: getDefaultMiddleware => getDefaultMiddleware({thunk: true}).concat(epicMiddleware),
  });

  if (process.env.NODE_ENV !== 'production') {
    if (module?.hot) {
      module.hot.accept('../reducers/rootReducer', () => {
        const newRootReducer: any = rootReducer;
        store.replaceReducer(newRootReducer);
      });
    }
  }

  epicMiddleware.run(rootEpic);

  return store;
}
